import { toastController } from '@ionic/vue';
import axios from 'axios';
import { getParams } from '@/services/users';
import utils from '@/services/utils/Utils';
import * as Sentry from '@sentry/vue';

const HasAttachmentsMixin = {
  data() {
    return {
      attachmentLink: null,
      toastButtons: [
        {
          text: 'Cliquez ici',
          handler: () => {
            window.open(this.attachmentLink, '_blank');
            this.attachmentLink = null;
          },
        },
      ],
    };
  },

  methods: {
    getAttachmentIconPath: utils.getAttachmentIconPath,

    /**
     * Get readable link from attachment
     * Then, download file from this link
     */
    async showAttachment(attachment) {
      if (!attachment.id) return;

      // get file link
      let requestConfig = { method: 'GET' };
      const outsourcingToken =
        this.$route.params && this.$route.params.outsourcingToken;
      if (outsourcingToken) {
        // Use an absolute URL to override default `pwa-api` baseURL
        requestConfig.url = `${process.env.VUE_APP_API_URL_OUTSOURCING}/driver/attachment/${outsourcingToken}/${attachment.id}`;
      } else {
        requestConfig.url = `/attachment/${attachment.id}`;
        Object.assign(requestConfig, await getParams());
      }

      let response;
      try {
        response = await axios(requestConfig);
      } catch (error) {
        Sentry.captureException(error);

        const toast = await toastController.create({
          message: 'Récupération impossible pour ce fichier.',
          color: 'danger',
          duration: 3000,
        });
        await toast.present();

        return;
      }

      /**
       * On iOS, our freshly generated links are not allowed to open
       * Because there is a little wait between the click and when we try to open.
       * So we use a toast has a workaround.
       *
       * We can not use a simple href, because we need Sanctum token in headers
       */
      this.attachmentLink = response.data;

      const toast = await toastController.create({
        buttons: this.toastButtons,
        message: 'Votre fichier est prêt !',
        duration: 15000,
        color: 'primary',
        position: 'bottom',
      });

      await toast.present();
    },
  },
};

export default HasAttachmentsMixin;
